/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_CloseInputs */

const en_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const it_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const nl_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pl_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fi_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const da_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const sv_story_bank_close = /** @type {(inputs: Story_Bank_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Story_Bank_CloseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_close = /** @type {((inputs?: Story_Bank_CloseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_CloseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_close(inputs)
	if (locale === "fr") return fr_story_bank_close(inputs)
	if (locale === "es") return es_story_bank_close(inputs)
	if (locale === "it") return it_story_bank_close(inputs)
	if (locale === "nl") return nl_story_bank_close(inputs)
	if (locale === "pl") return pl_story_bank_close(inputs)
	if (locale === "fi") return fi_story_bank_close(inputs)
	if (locale === "da") return da_story_bank_close(inputs)
	if (locale === "sv") return sv_story_bank_close(inputs)
	return en_story_bank_close(inputs)
});